import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { PrivateRoute } from 'navigation/router/components/routes/private-route';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PatientRoutes, routes } from 'routes';
import { PatientClinicianOnlyRoutes } from '../../config/routes-patient/routes-patient-patientId';
import {
  PatientRoutePattern,
  getPatientLinkUrl
} from '../utils/patient-route-helpers';

/**
 * This router handles the routes that a Clinician can access in the context of the Patient routes
 *
 * @param props
 * @returns
 */
export function ClinicianRouterForPatientRoutes(props: {
  patientId: string;
  patientInfo: PatientInfoState;
}) {
  // if (!doesUserHaveAssessments(props.patientInfo)) {
  //   return (
  //     <div>
  //       <Title>Safely caught error</Title>
  //       <Text>
  //         Patient {`'${props.patientId}'`} has no patient data. This can happen
  //         if the user has not completed their first assessment.
  //       </Text>
  //       <Text>
  //         If you think this is an error please contact us and include this URL:
  //         {` ${window.location.href}`}.
  //       </Text>
  //     </div>
  //   );
  // }

  return (
    <Switch>
      {PatientClinicianOnlyRoutes.map(route => (
        <PrivateRoute
          exact
          {...route}
          path={PatientRoutePattern + route.path}
          key={`${JSON.stringify(route.path)}`}
          redirectPath={'../'}
        />
      ))}

      <Route
        // Handler when the browser redirects to the second base patient route and the route did not match any earlier routes
        path={['/patient/:patientId']}
        render={() => (
          <Redirect
            to={getPatientLinkUrl(
              routes.clinician.patient.assessments as PatientRoutes,
              props.patientId
            )}
          />
        )}
      />
    </Switch>
  );
}
